import React from "react";
import PropTypes from "prop-types";
import {
  classToModules,
  getClassName,
  createBubbleEffect,
  toggleMoveClasses
} from "core/class";
import "./button.styl";
const ROOTELM = "aws-btn";
const ANIMATION_DELAY = 100;

const Anchor = props => <a {...props} />;
const Button = props => <button {...props} />;

export default class AwesomeButton extends React.Component {
  static propTypes = {
    action: PropTypes.func,
    onPress: PropTypes.func,
    ripple: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    element: PropTypes.func,
    href: PropTypes.string,
    placeholder: PropTypes.bool,
    title: PropTypes.string,
    rootElement: PropTypes.string,
    moveEvents: PropTypes.bool,
    size: PropTypes.string,
    style: PropTypes.object,
    cssModule: PropTypes.object,
    className: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.string,
    type: PropTypes.string,
    visible: PropTypes.bool,
    active: PropTypes.bool,
    blocked: PropTypes.bool,
    svgIcon: PropTypes.any
    //svgIcon: PropTypes.func
  };
  static defaultProps = {
    action: null,
    onPress: null,
    ripple: false,
    blocked: false,
    cssModule: null,
    children: null,
    disabled: false,
    title: null,
    element: null,
    href: null,
    className: null,
    moveEvents: true,
    placeholder: false,
    rootElement: ROOTELM,
    size: null,
    style: {},
    target: null,
    to: null,
    type: "primary",
    visible: true,
    active: false,
    svgIcon: null
  };
  constructor(props) {
    super(props);
    this.rootElement = props.rootElement || ROOTELM;
    this.extraProps = {}; // 입력받은 Property 정보 저장
    this.state = {
      disabled: props.disabled || (props.placeholder && !props.children)
    };
    this.checkProps(props);
  }

  /**
   * @method componentDidMount
   * @description 버튼을 포함하고 있는 Element를 컨테이너로 지정
   */
  componentDidMount() {
    this.container = this.button && this.button.parentNode;
  }

  componentWillReceiveProps(newProps) {
    this.checkPlaceholder(newProps);
    this.checkProps(newProps);
  }

  componentWillUnmount() {
    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
    }
  }

  /**
   * @method checkPlaceholder
   * @description 컴포넌트에 전달받은 property 중 placeholder property를 확인하여
   * disabled 속성을 결정한다.
   * @param {Object} newProps
   */
  checkPlaceholder(newProps) {
    const { disabled, placeholder, children } = newProps;
    if (placeholder === true) {
      if (!children) {
        // 컴포넌트 내부에 렌더링할 Children elements 를 전달 받지 않았다면 disabled <= true
        this.setState({
          disabled: true
        });
      } else {
        // 컴포넌트 내부에 렌더링할 Children elements 를 전달 받았다면 disabled <= false
        this.setState({
          disabled: false
        });
      }
    } else {
      // place holder 가 없다면, 전달 받은 disabled 속성을 그대로 부여 한다.
      this.setState({
        disabled
      });
    }
  }

  /**
   * @method checkProps
   * @description 컴포넌트에 전달된 Property 중, 사용되는 Property를 extraProps 멤버변수에 정리하고
   * renderComponent를 결정한다.
   * @param {Object} newProps
   */
  checkProps(newProps) {
    // 컴포넌트로 전달 받은 property 획득
    const { to, href, target, element } = newProps;
    // 입력받은 Property를 모두 extraProps 멤버 변수에 저장한다.
    this.extraProps.to = to || null;
    this.extraProps.href = href || null;
    this.extraProps.target = target || null;

    // 만약, 렌더링이 될 요소를 직접 Property 로 입력 받았다면, 입력받은 Element를
    // renderComponent로 지정한다.
    // 그렇지 않다면, 링크 property가 입력되었는지 유무에 따라 Anchor, 또는 Button  엘러먼트를
    // renderComponent로 지정한다.
    // renderComponent는 Button을 대표하는 Element 이다.
    this.renderComponent = element || (this.props.href ? Anchor : Button);
  }

  getRootClassName() {
    const { rootElement } = this;
    const {
      type,
      size,
      placeholder,
      children,
      visible,
      svgIcon,
      cssModule
    } = this.props;
    const { disabled, pressPosition } = this.state;
    const className = [
      this.rootElement,
      type && `${rootElement}--${type}`,
      size && `${rootElement}--${size}`,
      visible && `${rootElement}--visible`,
      svgIcon && `${rootElement}--has-svgicon`,
      (placeholder && !children && `${rootElement}--placeholder`) || null
    ];
    if (disabled === true) {
      className.push(`${rootElement}--disabled`);
    }
    if (pressPosition) {
      className.push(pressPosition);
    }
    if (this.props.className) {
      className.push(...this.props.className.split(" "));
    }
    if (cssModule && cssModule["aws-btn"]) {
      return classToModules(className, cssModule);
    }
    return className
      .join(" ")
      .trim()
      .replace(/[\s]+/gi, " ");
  }

  pressIn() {
    if (this.state.disabled === true || this.props.blocked === true) {
      return;
    }
    this.pressed = new Date().getTime();
    this.setState({
      pressPosition: `${this.rootElement}--active`
    });
  }
  pressOut() {
    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
    }
    const diff = new Date().getTime() - this.pressed;
    if (this.props.ripple === true) {
      //this.createBubble(event);
    }
    if (typeof window !== "undefined" && this.button) {
      const eventTrigger = new Event("action");
      this.button.dispatchEvent(eventTrigger);
    }
    this.action();
    this.clearTimer = setTimeout(() => {
      this.clearPress();
    }, ANIMATION_DELAY - diff);
  }
  clearPress(force) {
    toggleMoveClasses({
      element: this.container,
      root: this.rootElement,
      cssModule: this.props.cssModule
    });
    const pressPosition =
      this.props.active && !force ? `${this.rootElement}--active` : null;
    this.setState({
      pressPosition
    });
  }
  action() {
    const { action, onPress } = this.props;

    if (this.button) {
      if (action) {
        action(this.container);
        return;
      }
      if (onPress) {
        onPress(this.container);
      }
    }
  }

  moveEvents() {
    const events = {
      onClick: event => {
        if (this.props.href && this.state.disabled) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      onMouseLeave: () => {
        this.clearPress();
      },
      onMouseDown: event => {
        if (event && event.nativeEvent.which !== 1) {
          return;
        }
        this.pressIn();
      },
      onMouseUp: event => {
        if (this.state.disabled === true || this.props.blocked === true) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        this.pressOut();
      }
    };
    if (this.props.moveEvents === true) {
      events.onMouseMove = event => {
        if (this.state.disabled === true) {
          return;
        }
        const { button } = this;
        const { left } = button.getBoundingClientRect();
        const width = button.offsetWidth;
        const state =
          event.pageX < left + width * 0.3
            ? "left"
            : event.pageX > left + width * 0.65
            ? "right"
            : "middle";

        toggleMoveClasses({
          element: this.container,
          root: this.rootElement,
          cssModule: this.props.cssModule,
          state
        });
      };
    } else {
      events.onMouseEnter = () => {
        toggleMoveClasses({
          element: this.container,
          root: this.rootElement,
          cssModule: this.props.cssModule,
          state: "middle"
        });
      };
    }
    return events;
  }

  render() {
    const RenderComponent = this.renderComponent;
    const { title, style, svgIcon, cssModule, children } = this.props;
    return (
      <RenderComponent
        style={style}
        className={this.getRootClassName()}
        role="button"
        title={title}
        {...this.extraProps}
        {...this.moveEvents()}
      >
        <span
          ref={button => {
            this.button = button;
          }}
          className={getClassName(`${this.rootElement}__wrapper`, cssModule)}
        >
          <span
            ref={content => {
              this.content = content;
            }}
            className={getClassName(`${this.rootElement}__content`, cssModule)}
          >
            {svgIcon && svgIcon}
            <span
              ref={child => {
                this.child = child;
              }}
            >
              {children}
            </span>
          </span>
        </span>
      </RenderComponent>
    );
  }
}
